// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/calm-app-square.svg';

export const CalmAppSquare = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
